<!-- Hero Section -->
<section class="page-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <p class="hero-label">THE TEAM</p>
    <h1 class="hero-title">Our Artists</h1>
    <p class="hero-subtitle">Passionate professionals dedicated to natural beauty and expert technique</p>
  </div>
</section>

<!-- Artist Profile: Paige -->
<section class="artist-section">
  <div class="artist-inner">
    <div class="artist-layout">
      <div class="artist-image">
        <img src="../../assets/images/paige_profile.jpg" alt="Paige, Owner and Lead Stylist">
      </div>
      <div class="artist-info">
        <p class="artist-label">OWNER & LEAD STYLIST</p>
        <h2>Paige</h2>
        <p class="artist-bio">A certified cosmetologist from The Salon Professional Academy in Appleton, Paige is dedicated to creating natural, healthy beauty through expert technique and premium products.</p>
        <p class="artist-bio">With specialized certifications in all hair extension types — volume wefts, hand-tied wefts, keratin tips, i-tips, tape-ins, and clip-ins — along with lash lifts, brow lamination, and classic, hybrid, and volume extensions, Paige brings comprehensive expertise to every appointment.</p>
        <p class="artist-bio">Her philosophy centers on individual beauty and long-term hair health, specializing in natural blonding, lived-in color, and sustainable hair care. Through continued education and intentional practice, she brings her passion for natural aesthetics to every client at Velour Salon.</p>
        
        <div class="artist-specialties">
          <p class="specialties-label">SPECIALTIES</p>
          <div class="specialty-tags">
            <span>Natural Blonding</span>
            <span>Lived-in Color</span>
            <span>Hair Extensions</span>
            <span>Lash Extensions</span>
            <span>Brow Lamination</span>
          </div>
        </div>
        
        <div class="artist-social">
          <a href="https://www.instagram.com/veloursalon.paige" target="_blank"><i class="fa-brands fa-instagram"></i></a>
          <a href="https://linktr.ee/veloursalon" target="_blank"><i class="fa-solid fa-link"></i></a>
        </div>
        
        <a class="artist-book" href="https://www.vagaro.com/veloursalonpaige" target="_blank">Book With Paige <i class="fa-solid fa-arrow-right"></i></a>
      </div>
    </div>
  </div>
</section>

<!-- Divider -->
<section class="artist-divider">
  <div class="divider-line"></div>
</section>

<!-- Artist Profile: Lauren -->
<section class="artist-section alt-bg">
  <div class="artist-inner">
    <div class="artist-layout">
      <div class="artist-info">
        <p class="artist-label">OWNER & LEAD STYLIST</p>
        <h2>Lauren</h2>
        <p class="artist-bio">Lauren is a passionate stylist and co-owner of Velour Salon, bringing her own unique artistry and expertise to every client. With a deep commitment to natural beauty and healthy hair, she crafts personalized looks that enhance each client's individual style.</p>
        <p class="artist-bio">Her warm, welcoming approach and attention to detail make every appointment feel like a true experience. Lauren believes in the power of premium products and continued education to deliver the best results for her clients.</p>
        
        <div class="artist-specialties">
          <p class="specialties-label">SPECIALTIES</p>
          <div class="specialty-tags">
            <span>Color Specialist</span>
            <span>Natural Styling</span>
            <span>Blonding</span>
            <span>Hair Health</span>
          </div>
        </div>
        
        <div class="artist-social">
          <a href="https://www.instagram.com/glowithlolo/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
          <a href="https://linktr.ee/glowithlolo" target="_blank"><i class="fa-solid fa-link"></i></a>
        </div>
        
        <a class="artist-book" href="https://book.squareup.com/appointments/3vhshh9bgxt5qf/location/LGF8BX08PFET1/services" target="_blank">Book With Lauren <i class="fa-solid fa-arrow-right"></i></a>
      </div>
      <div class="artist-image">
        <img src="../../assets/images/lauren_profile.jpg" alt="Lauren, Owner and Lead Stylist">
      </div>
    </div>
  </div>
</section>

<!-- Divider -->
<section class="artist-divider">
  <div class="divider-line"></div>
</section>

<!-- Artist Profile: Samantha -->
<section class="artist-section">
  <div class="artist-inner">
    <div class="artist-layout">
      <div class="artist-image">
        <img src="../../assets/images/samantha_profile.jpg" alt="Samantha, Lash Expert">
      </div>
      <div class="artist-info">
        <p class="artist-label">LASH EXPERT</p>
        <h2>Samantha</h2>
        <p class="artist-bio">Samantha is Velour Salon's lash expert, dedicated exclusively to the art of beautiful, long-lasting lashes. With a meticulous eye for detail and a passion for enhancing natural beauty, she creates customized lash looks tailored to each client.</p>
        <p class="artist-bio">From classic to volume sets, Samantha brings precision and care to every appointment, ensuring stunning results that frame and elevate your eyes.</p>

        <div class="artist-specialties">
          <p class="specialties-label">SPECIALTIES</p>
          <div class="specialty-tags">
            <span>Classic Lashes</span>
            <span>Volume Lashes</span>
            <span>Hybrid Lashes</span>
            <span>Lash Fills</span>
          </div>
        </div>

        <div class="artist-social">
          <a href="https://www.instagram.com/thelashvaultwi/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
        </div>

        <a class="artist-book" href="https://samanthaguerra.glossgenius.com/" target="_blank">Book With Samantha <i class="fa-solid fa-arrow-right"></i></a>
      </div>
    </div>
  </div>
</section>

<!-- Divider -->
<section class="artist-divider">
  <div class="divider-line"></div>
</section>

<!-- Artist Profile: Hannah -->
<section class="artist-section alt-bg">
  <div class="artist-inner">
    <div class="artist-layout">
      <div class="artist-info">
        <p class="artist-label">NAIL ARTIST</p>
        <h2>Hannah</h2>
        <p class="artist-bio">Hannah is Velour Salon's nail artist, specializing in professional Gel-X nails that combine durability with a flawless, natural look. Her dedication to quality and craftsmanship shines through in every set.</p>
        <p class="artist-bio">Whether you're after a clean, classic style or something more expressive, Hannah delivers beautiful, long-lasting results with a personalized touch.</p>

        <div class="artist-specialties">
          <p class="specialties-label">SPECIALTIES</p>
          <div class="specialty-tags">
            <span>Gel-X Nails</span>
            <span>Nail Art</span>
            <span>Manicures</span>
            <span>Nail Health</span>
          </div>
        </div>

        <div class="artist-social">
          <a href="https://www.instagram.com/thepolishedparlour_byhannah/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
        </div>

        <a class="artist-book" href="https://thepolishedparlour.glossgenius.com/" target="_blank">Book With Hannah <i class="fa-solid fa-arrow-right"></i></a>
      </div>
      <div class="artist-image">
        <img src="../../assets/images/hannah_profile.jpg" alt="Hannah, Nail Artist">
      </div>
    </div>
  </div>
</section>

<!-- Values Section -->
<section class="values-section">
  <div class="values-inner">
    <p class="values-label">OUR VALUES</p>
    <h2 class="values-heading">What Sets Us Apart</h2>
    <div class="values-grid">
      <div class="value-item">
        <h3>Premium Products</h3>
        <p>We exclusively use the highest quality, sustainably sourced professional products for lasting results.</p>
      </div>
      <div class="value-item">
        <h3>Continued Education</h3>
        <p>Our artists invest in ongoing training to master the latest techniques in natural hair care.</p>
      </div>
      <div class="value-item">
        <h3>Intentional Practice</h3>
        <p>Every service is thoughtful and personalized, honoring your unique natural beauty.</p>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="artist-cta">
  <h2>Experience the Velour Difference</h2>
  <p>Book your consultation and discover your best natural look.</p>
  <div class="cta-buttons">
    <a class="cta-button" href="https://www.vagaro.com/veloursalonpaige" target="_blank">Book With Paige</a>
    <a class="cta-button cta-outline" href="https://book.squareup.com/appointments/3vhshh9bgxt5qf/location/LGF8BX08PFET1/services" target="_blank">Book With Lauren</a>
    <a class="cta-button cta-outline" href="https://samanthaguerra.glossgenius.com/" target="_blank">Book With Samantha</a>
    <a class="cta-button cta-outline" href="https://thepolishedparlour.glossgenius.com/" target="_blank">Book With Hannah</a>
  </div>
</section>